<template>
    <div class="box">
        <div class="news">
            <div class="newsleft">
                <div class="leftpic">
                    <img
                            src="../../static/investment.png"
                            style="height: 80px;"
                    />
                </div>
                <div class="leftpic1">
                    <img src="../../static/line.png" style="width: 100%; height: 100%"/>
                </div>
                <div class="leftTitle">投资项目</div>
                <div class="tabs">
                    <div @click="tabChange(item)" v-for="item in classList" :key="item.dictSort">
                        <p :class="{ active: tabIndex == item.dictSort }">{{ item.dictLabel }}</p>
                        <div class="line" v-if="tabIndex == item.dictSort"></div>
                    </div>


                </div>
                <div class="jia" @click="jumpList">
                    <img src="../../static/jia.png" style="width: 100%; height: 100%"/>
                </div>
            </div>
            <div class="newsright">
                <isBuilding v-if="list.length<=0 || queryParams.classify==2" style="margin-left: -100px;"></isBuilding>
                <div class="right_li" v-for="item in list" :key="item.id" v-if="queryParams.classify!=2">
                    <img
                            :src="item.coverOssUrl"
                            style="width: 100%; height: 100%"
                    />
                    <div class="lizs">
                        <div class="top_text">{{ item.name }}</div>
                        <div class="bot_text" v-html="item.sketch"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import isBuilding from "@/components/isBuilding.vue";
export default {
    name: "investment",
    components:{
      isBuilding
    },
    data() {
        return {
            tabIndex: 0,
            classList: [],
            list: [],
            queryParams: {
                pageSize: 4,
                pageNum: 1,
                classify: ""
            }
        };
    },
    created() {
        this.getclass()
    },
    methods: {
        // 跳转文章列表
        jumpList() {
          this.$router.push({ path: "/product", query: {
              type: 'tzxm',
              tabInd: 4
            } });
        },
        tabChange(row) {
            this.tabIndex = row.dictSort;
            this.getList(row.dictSort)
        },
        getclass() {
            this.$api.getTZClassify().then(res => {
                // console.log(res, '----投资分类')
                this.classList = res.data.length != 0 ? res.data : []
                this.tabIndex = res.data[0].dictSort
                this.getList(res.data[0].dictSort ? res.data[0].dictSort : 0)
            })
        },
        getList(dictSort) {
            this.queryParams.classify = dictSort
            var isIndexShow = dictSort==1 ? 1 : 0;
            this.$api.getTZList({
              isIndexShow,
              ...this.queryParams,
            }).then(res => {
                // console.log(res, '---huw1')
                this.list = res.rows.length != 0 ? res.rows : []
            })
        },
    },
};
</script>

<style scoped lang="less">
.active {
  font-weight: 600;
  font-size: 1.25rem /* 20/16 */;
  color: #1e439b;
}

.box {
  min-width: 93.75rem /* 1500/16 */;
  background-color: #ffffff;
  margin: 0 auto;

  .news {
    height: 100%;
    display: flex;
    box-sizing: border-box;
    padding: 100px 6.5rem;
    width: 93.75rem /* 1500/16 */;
    margin: 0 auto;
    min-width: 93.75rem /* 1500/16 */;

    .newsleft {
      margin-right: 8.125rem /* 100/16 */;

      .leftpic {
        width: 17.6875rem /* 283/16 */;
        height: 5.9375rem /* 95/16 */;
        // margin-bottom: 30px;
      }

      .leftpic1 {
        width: 5.5625rem /* 89/16 */;
        margin-top: 1.9375rem /* 31/16 */;
        margin-bottom: 3.75rem /* 60/16 */;
      }

      .leftTitle {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: bold;
        font-size: 2.1875rem /* 35/16 */;
        color: #333333;
        line-height: 0rem /* 0/16 */;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }

      .tabs {
        margin-top: 9.625rem /* 154/16 */;
        margin-bottom: 8.6875rem /* 139/16 */;
      }

      .line {
        width: 5rem /* 80/16 */;
        height: 0.125rem /* 2/16 */;
        background: #1e439b;
        border-radius: 0px 0px 0px 0px;
      }

      .tabs div {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 1.25rem /* 20/16 */;
        color: #333333;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-bottom: 2.375rem /* 38/16 */;
        cursor: pointer;
      }

      .jia {
        width: 3.125rem /* 50/16 */;
        height: 3.125rem /* 50/16 */;
        cursor: pointer;
      }
    }

    .newsright {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;

      .right_li {
        width: 26.875rem /* 430/16 */;
        height: 21.875rem /* 350/16 */;
        background-color: pink;
        // margin-right: 1.25rem /* 20/16 */;
        position: relative;
        cursor: pointer;

        .lizs {
          width: 100%;
          height: 4.9375rem /* 79/16 */;
          background: linear-gradient(180deg,
          rgba(0, 0, 0, 0.102) 0%,
          #545454 100%);
          position: absolute;
          bottom: 0;
          text-align: center;
          padding: 1rem /* 16/16 */;

          .top_text {
            font-size: 1.125rem /* 18/16 */ /* 16/16 */;
            letter-spacing: 0.0625rem /* 1/16 */;
            font-weight: 550;
            color: #fff;

            width: 390px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

          }

          .bot_text {
            font-size: 1rem /* 16/16 */;
            margin-top: 0.4375rem /* 7/16 */ /* 14/16 */;
            color: #fff;
              width: 390px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
          }
        }
      }
    }
  }
}
</style>
